import type {CueCard} from '../../glossary/consts/cue-card-collection';
import {OpenableModals} from '../../openable-modals';

export const CUE_CARDS: CueCard[] = [
    {
        settingsKey: 'moveLeadsThroughPipeline',
        title: 'Move leads through your pipeline',
        description:
            'Track your leads on a simple board and advance them through your pipeline stages.',
        thumbnailPath: '/include/images/onboarding/lead-arrow.svg',
        thumbnailPosition: 'centered',
        backgroundColor: 'greenDk',
        location: 'onboarding-sidebar',
        cta: {
            text: 'Try with a lead',
            actionType: 'routed-link',
            newTab: false,
            url: '/leads?board',
        },
    },
    {
        settingsKey: 'defaultStagesetOnboardingWizard',
        title: 'Customize a pipeline for your business',
        description:
            'Answer a few questions about your company, and we’ll customize your pipeline with appropriate stages and goals.',
        thumbnailPath: '/include/images/onboarding/lead-arrow-group.svg',
        thumbnailPosition: 'centered',
        backgroundColor: 'focusBlue',
        location: 'onboarding-sidebar',
        cta: {
            text: 'Get started',
            actionType: 'modal',
            openableModalId: OpenableModals.DESIGN_PIPELINE_WIZARD,
        },
    },
    {
        settingsKey: 'create_broadcast',
        title: 'Create an email campaign using a starter template',
        description:
            'Use Nutshell Campaigns to craft and send email broadcasts. Select from a range of professionally designed templates.',
        thumbnailPath: '/include/images/onboarding/email-marketing.svg',
        thumbnailPosition: 'full',
        backgroundColor: 'plumXlt',
        location: 'onboarding-sidebar',
        cta: {
            text: 'Create a broadcast',
            actionType: 'routed-link',
            url: '/email-marketing/broadcasts',
        },
    },
    {
        settingsKey: 'create_form',
        title: 'Start collecting leads with a form',
        description:
            'Embed a Nutshell form on your website to collect contact information and lead details.',
        thumbnailPath: '/include/images/onboarding/sidebar-form.svg',
        thumbnailPosition: 'centered',
        backgroundColor: 'plum',
        location: 'onboarding-sidebar',
        cta: {
            text: 'Create a form',
            actionType: 'routed-link',
            url: '/email-marketing/forms',
        },
    },
];
